import { combineReducers } from "redux";
import Login from "./login";
import Establishment from "./establishment"
import Branchs from "./branchs";
import Messages from "./messages";
import WebSocket from "./socket";
import ChatsWithNewMessages from "../reducers/chatsWithNewMessages";


export default combineReducers({ 
    login: Login,
    branchs: Branchs,
    messages: Messages,
    websocket: WebSocket,
    chatWithNewMessageIdList: ChatsWithNewMessages,
    establishment: Establishment
});
